export default "<east-slider class=\"east-slider\">\n</east-slider>\n";